 const FBconfig = setFBConfig();

function setFBConfig() {
    if (!process.env.VUE_APP_FB_CONFIG) {
        console.warn('missing VUE_APP_FB_CONFIG')
    } else {
        return JSON.parse(process.env.VUE_APP_FB_CONFIG)
    }
}

export default FBconfig